var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "action-palette",
    },
    [
      _c("div", { staticClass: "action-palette-top" }, [
        _c(
          "div",
          {
            staticClass: "search-container",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            !_vm.showSearchBar
              ? _c("a-icon", {
                  class: { hide: _vm.showSearchBar },
                  staticStyle: { "font-size": "21px" },
                  attrs: { type: "search" },
                  on: { click: _vm.toggleSearchBar },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchText,
                      expression: "searchText",
                    },
                  ],
                  ref: "searchInput",
                  class: { show: _vm.showSearchBar },
                  attrs: {
                    type: "text",
                    placeholder: "Search...",
                    id: "action-palette-search-bar",
                  },
                  domProps: { value: _vm.searchText },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.hideSearchBar.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchText = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.searchText && _vm.showSearchBar
                  ? _c("a-icon", {
                      staticClass: "clear-icon",
                      attrs: { type: "delete" },
                      on: { click: _vm.clearSearchText },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "justify-content": "end",
            },
          },
          [
            _vm.bar !== 0
              ? _c("a-icon", {
                  staticStyle: { "font-size": "23px" },
                  attrs: { type: "close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close-menu", 0)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.filteredActionPalette, function (ap, i) {
        return ap.enabled
          ? _c("section", { key: i }, [
              _c("div", { staticClass: "title" }, [
                _c("div", { staticClass: "title-content" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "chatbotv2." +
                            (ap.group.split(" ").length > 1
                              ? ap.group.split(" ").join("_")
                              : ap.group)
                        )
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "items" },
                _vm._l(ap.items, function (item) {
                  return !item.disabled
                    ? _c(
                        "button",
                        {
                          key: item.id,
                          staticClass: "item chatbot-btn",
                          attrs: { draggable: true },
                          on: {
                            dragstart: function (ev) {
                              return _vm.dragStart(ev, item.id)
                            },
                            drag: function (ev) {
                              return _vm.dragStart(ev, item.id)
                            },
                            dragend: function ($event) {
                              return _vm.dragEnd()
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("BlockIconPreview", {
                                staticClass: "img",
                                staticStyle: { "font-size": "24px" },
                                attrs: { "block-type": item.id },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center align-content-center justify-content-start",
                            },
                            [
                              _c("span", { staticClass: "blockTypeText" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm
                                        .$t("chatbotv2." + item.id)
                                        .toLocaleLowerCase(_vm.$i18n.locale)
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e()
                }),
                0
              ),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.importedCustomBlocks.length > 0
        ? _c("section", [
            _c("div", { staticClass: "title" }, [
              _c("div", { staticClass: "title-content" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("chatbotv2.customBlocks") || "Custom Blocks"
                    ) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items" },
              _vm._l(_vm.importedCustomBlocks, function (block) {
                return _c(
                  "button",
                  {
                    key: block.blockId,
                    staticClass: "item chatbot-btn",
                    attrs: { draggable: true },
                    on: {
                      dragstart: function (ev) {
                        return _vm.dragStartCustomBlock(ev, block)
                      },
                      drag: function (ev) {
                        return _vm.dragStartCustomBlock(ev, block)
                      },
                      dragend: function ($event) {
                        return _vm.dragEnd()
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: {
                            "font-size": "24px",
                            color: "#9c27b0",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$_.get(block, "block.icon", "extension")
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center align-content-center justify-content-start",
                      },
                      [
                        _c("span", { staticClass: "blockTypeText" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                block.customName ||
                                  _vm.$_.get(
                                    block,
                                    "block.name",
                                    "Bilinmeyen Blok"
                                  )
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "title-content" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("chatbotv2.blockMarket") || "Block Market") +
                "\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "items" }, [
          _c(
            "button",
            {
              staticClass: "item chatbot-btn browse-market-btn",
              on: { click: _vm.openBlockMarket },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center align-content-center justify-content-start",
                },
                [
                  _c("span", { staticClass: "blockTypeText" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("chatbotv2.browseBlockMarket") ||
                            "Browse Block Market"
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "span",
        {
          staticClass: "material-icons",
          staticStyle: { "font-size": "24px", color: "#1890ff" },
        },
        [_vm._v("\n                        store\n                    ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }